import { Component, OnInit, Input,SimpleChanges,HostListener, ViewChild, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ENDPOINTS,ORG_DETAILS } from 'src/app/app.config';
import { ActivatedRoute, Router, NavigationEnd, Params,NavigationExtras } from '@angular/router';
import { Options, LabelType } from 'ng5-slider';

// import { BreadcrumbsService } from '../breadcrumbs/breadcrumbs.service';
import { ProductFilterService } from './product-filter.service';
import { ProductListingService } from '../product-listing/product-listing.service';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service'
import { start } from 'repl';
import { Console } from 'console';
import { exit } from 'process';
import { SEOService } from 'src/app/seo.service';
@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html'
})
export class ProductFilterComponent implements OnInit {
  prices1: number[] = [0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650];
  selectedRange: { min: any, max: any } = { min: this.prices1[0], max: this.prices1[13] };
  prices2: number[] = [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];
  selectedRange1: { min: any, max: any } = { min: this.prices2[0], max: this.prices2[10] };
  public limits: object
  originalRange: any;
  public outletId: any;
  originalRange1: any;
  subRanges: string[] = [];
  catsted: string[]=[];
  public value;
  // active = 'dontcheck';
  currentPageUrl;
  ageEncode = '';
  active = '';
  active1 = '';
  active2='';
  activeauthor='';
  public  allData:any;
  public facet:any;
  public day90;
  public day60;
  isExpanded: boolean = true;
  public outOfStock;
  stockDetails:any=[];
  brandall:any = [];
  deeracolor=[];
  deeradimension=[];
  ageFilter: string[] = [];
  isChecked =true;
  public values1;
  public values2;
  public values3;
   intialVal:boolean = true;
   collide:boolean = true;
   myboolean:boolean = true;
   iscatfilter:boolean = false;
   brandoptions: boolean = false;
   exoticPlants:boolean = false;
   indoorPlants:boolean = false;
   miniaturePlants:boolean = false;
   outdoorPlants:boolean = false;
   clearPlant:boolean = false;
    public categoryName;
    public categoryName1;
    public categoryName2;
    public categoryName3;
    public categoryName4;
    public subCategory;
    allCategories:any;
    testValue;
    categoryincore
    brandstore:any = [];
    categorystore:any = [];
    collapseSix = document.getElementById('collapseSix');
    collapseSeven = document.getElementById('collapseSeven');
    sliderOne = document.getElementById("slider-1");
    sliderTwo = document.getElementById("slider-2");
    inputValue1: any = document.getElementById("slider-1");
    inputValue2: any = document.getElementById("slider-2");
    minOutput = document.getElementById('minOutput');
    maxOutput = document.getElementById('maxOutput');
    minGap = 50;
    minGap1 = 100;
    sliderLimit: any;
    authorQuery:any;
    input = document.querySelector("input");
    categoryname;
    bestCategory;
    public categoryname1;
    public parentCategory;
    mobileMedia = window.matchMedia("(max-width: 600px)");

    instFilter: {  name: string }[]=[{"name":"School"},{"name":"College"},{"name":"University"},{"name":"Tutorials"},{"name":"Academy"},{"name":"Entrance Exams"}]
    // public outletId: any;
    institutionFilter: {  name: string }[]=[{"name":"School"},{"name":"College"},{"name":"University"},{"name":"Tutorials"},{"name":"Academy"},{"name":"Entrance Exams"}];
    standardFilter: {  name: string }[]=[{"name":"XII"},{"name":"XI"},{"name":"X"},{"name":"IX"},{"name":"VIII"},{"name":"VII"}];
    mediumFilter: {  name: string }[]=[{"name":"Tamil"},{"name":"English"},{"name":"Hindi"},{"name":"Marathi"},{"name":"Kannada"},{"name":"Telugu"}];
    subjectFilter: {  name: string }[]=[{"name":"English"},{"name":"Mathematics"},{"name":"Physics"},{"name":"Chemistry"},{"name":"Tamil"},{"name":"Bio-Botany"}];
    yearFilter: {  name: string }[]=[{"name":"2024"},{"name":"2023"},{"name":"2022"},{"name":"2021"},{"name":"2020"},{"name":"2019"}];
    affiliationFilter: {  name: string }[]=[{"name":"TNSB"},{"name":"CBSE"},{"name":"CISCE"}];
    @ViewChild('collapseTwelve', { read: ElementRef, static:false }) collapseTwelve: ElementRef;
    @ViewChild('collapseThirteen', { read: ElementRef, static:false }) collapseThirteen: ElementRef;
// categories:any = 
// [
//               {
//                   "name": "category1",
//                   "subcategories": [
//                       {
//                           "name": "subcategory1",
//                           "subcategories": [
//                               {
//                                   "name": "subcategory1.2",
//                                   "subcategories": [
//                                     {
//                                         "name": "subcategory1.2.1",
//                                         "subcategories": [
//                                           {
//                                               "name": "subcategory1.2.1.1" ,
//                                               "subcategories": [
//                                                 {
//                                                     "name": "subcategory1.2.1.1.1",                                               
//                                                 }
//                                               ] 
                                                                                            
//                                           }
//                                         ]
//                                     }
//                                   ]
//                               }
//                           ]
//                       },
//                       {
//                           "name": "subcategory2"
//                       }
//                   ]
//               },
//               {
//                   "name": "category2"
//               },
//               {
//                   "name": "category3"
//               }
//           ]
  @Input() filters: any;
  @Input() themes: any;
  @Input() finish: any;
  @Input() features: any;
  @Input() prices: any;
  @Input() priceRange: any;
  @Input() size: any;
  @Input() thickness: any;
  @Input() color: any;
  @Input() age: any;
  @Input() affiliation: any;
  @Input() standard: any;
  @Input() subject: any;
  @Input() year: any;
  @Input() price_range: any;
  @Input() type: any;
  @Input() material: any;
  @Input() author: any;
  @Input() categoriesList: any;
  @Input() categoryValue: any;
  @Input() days: any;
  @Input() configTitle: any;
  _categoriesList: any;
  
// get categoriesList(): any {
//     return this._categoriesList;
// }
// @Input() set categoriesList(value: any) {
//   if(value.length>0)
//   {
//     this.categoriesList=value;
//   }
 
   
// }
ngAfterContentChecked()
{
  
}
ngAfterViewInit() {
  //get your element here
  var queryparams;
  var sub;
  var parent =[];
  let reqData = {
    "domain_name": ORG_DETAILS.DOMAIN_NAME,
    "user_id": null,
    "outlet_id":Number(this.outletId),
    "extras": {
      "find": {
      },
      "pagination": false,
      "paginationDetails": {
        "limit": 1,
        "pagesize": 25
      },
      "sorting": true,
      "sortingDetails": {
        "sortfield": "sort_order",
        "sortorder": +1
      }
    }
  }
  if(this.configTitle==='BestGifts' || this.configTitle==='BombayHardware'|| this.configTitle==='SriSenbaga'|| this.configTitle==='Karupattiraja'|| this.configTitle==='Cle' || this.configTitle==='Carience' || this.configTitle==='Beaubelle'){
  this.route.url.subscribe((urlSegments) => {
    console.log('URL Segments:', urlSegments);

    if (urlSegments.length === 1 && urlSegments[0].path === 'productListing') {
      // Case: /productListing (No additional segments)
      console.log('Navigated to /productListing');
      this.categoryname = ''; // Reset currentCategoryTaz or handle accordingly
      this.cate = []
    } else if (urlSegments.length >= 1) {
      // Case: /productListing/<Category>
      console.log("urlSegments",urlSegments)
      const encoded = urlSegments[urlSegments.length - 1].path;
      let uniqueName = encoded;
      uniqueName = uniqueName.replace(/-/g, ' '); // Replace single hyphens
      console.log("After replacing single hyphens:", uniqueName);
      
      uniqueName = uniqueName.replace(/\s{3}/g, ' - ') // Format dashes surrounded by spaces
      console.log("Final uniqueName:", uniqueName);
      console.log('Navigated to category:', uniqueName);
      this.categoryname = uniqueName; // Assign the category name
      this.cate=[this.categoryname]
      this.bestCategory = uniqueName
      this.active = this.categoryname
    }
     
  });
}
else{
  this.route.queryParamMap.subscribe(params => queryparams = params.getAll('terms'));
  if(queryparams[1]!='')
  {
    this.cate=queryparams[1];
    this.categoryincore = queryparams[1];
    this.categoryname=queryparams[1];
  } 
  else if(this.configTitle==='KatbookStore'){
    if(queryparams[1]==''){
    queryparams[1] = []
    }
  }
}
  sub=this.cate[0]
  // if(this.configTitle!=='Cle'){
    this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
      resp => {
        this.allCategories = resp.result.data;
        for(let i=0;i<this.allCategories.length;i++){
          parent.push(this.allCategories[i].name)
        }
        console.log("ppaodkvbdj",this.cate)
        // if((this.configTitle==='BombayHardware'||this.configTitle==='Vimpro') && this.cate[0].length>1){
          if( (this.configTitle==='BombayHardware' || this.configTitle==='SpecialWires' || this.configTitle==='Babys Pride') && this.cate[0].length>0){
          // if((this.cate[0].length>1 && this.configTitle==='BombayHardware') || (this.configTitle==='Vimpro' && this.cate[0].length>1) ){
          if(this.cate.length==0){
            this.clearAll()
            this.active="";
          }
          else if(parent.includes(this.cate[0])){
            this.checkedevt1('-',this.cate[0])
          }
          else {
            for(let j=0;j<this.allCategories.length;j++){
              if(this.allCategories[j].subcategories!=null)
              {
                 for(let k=0;k<this.allCategories[j].subcategories.length;k++){
                if(this.cate[0]==this.allCategories[j].subcategories[k].name){
                  this.checkedevt1('-',this.allCategories[j].name)
                  this.checkedevt1('-',this.allCategories[j].subcategories[k].name)
                  if(this.configTitle==='Deera'){
                    
                    this.active2="";
                    // this.deeracolor=[];
                    this.active2=this.allCategories[j].subcategories[k].sub_category[0].color;
                      console.log("facettttttttttt"+this.allCategories[j].subcategories[k].sub_category[0].color)
                      this.deeracolor.push(this.allCategories[j].subcategories[k].sub_category[0].color)
                  }
                }
              }
              }
            }
          }
        }
      });
  // }


    
}
ngOnChanges(){
  if(this.configTitle!=='Cle' && this.configTitle!=='Deera'){
    if(this.localService.get('allProducts')!='all'){
      console.log("tfin",this.localService.get('allProducts'))
      var queryparams;
      var sub;
      var parent =[];
      let reqData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "outlet_id":Number(this.outletId),
        "extras": {
          "find": {
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 1,
            "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "sort_order",
            "sortorder": +1
          }
        }
      }
      this.route.queryParamMap.subscribe(params => queryparams = params.getAll('terms'));
      if(queryparams[1]!='')
      {
        this.cate=queryparams[1];
        this.categoryname=queryparams[1];
      } 
      else if(this.configTitle==='KatbookStore'){
        if(queryparams[1]==''){
        queryparams[1] = []
        }
      }
      sub=this.cate[0]
      if(this.configTitle==='SriSenbaga' && queryparams[19]!='' && queryparams[19]!=undefined ){
        console.log("queryparams[19]",queryparams[19])
this.activeauthor = queryparams[19]
this.authorQuery = queryparams[19]
      }

      this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
        resp => {
          this.allCategories = resp.result.data;

          for(let i=0;i<this.allCategories.length;i++){
            parent.push(this.allCategories[i].name)
          }
          
          if((this.configTitle==='BombayHardware'|| this.configTitle==='SpecialWires'||this.configTitle==='Kubendran'||this.configTitle==='Vimpro') && this.cate[0].length>1){
            if(this.cate.length==0){
              this.clearAll()
              this.active="";
            }
            else if(parent.includes(this.cate[0])){
              this.checkedevt1('-',this.cate[0])
            }
            else {
              for(let j=0;j<this.allCategories.length;j++){
                if(this.allCategories[j].subcategories!=null)
                {
                  for(let k=0;k<this.allCategories[j].subcategories.length;k++){
                    if(this.cate[0]==this.allCategories[j].subcategories[k].name){
                      this.checkedevt1('-',this.allCategories[j].name)
                      this.checkedevt1('-',this.allCategories[j].subcategories[k].name)
                    }
                  }
                }
                
              }
            }
          }
        });
    }
  }

}

ngAfterViewChecked(){
  // if(this.configTitle=="KatbookStore" ){
  //   const collapsibleDiv = document.getElementById('collapsibleDiv');
  //   if(collapsibleDiv){
  //     console.log("1111")
  //     collapsibleDiv.setAttribute('aria-expanded', 'false');


  //   }
    


  // }
  
if(this.configTitle!=="Babys Pride" && this.configTitle!=="LushNGreen"&& this.configTitle!=="KatbookStore"&& this.configTitle!=="Karupattiraja" && this.configTitle!=="ShubhCards" && this.configTitle!=="PaulCaroline" && this.configTitle!=="Deera" && this.configTitle!=="SriSenbaga" && this.configTitle!=="Cle" && this.configTitle!=="Carience" && this.configTitle!=='Beaubelle'){
  let reqData = {
    "domain_name": ORG_DETAILS.DOMAIN_NAME,
    "user_id": null,
    "outlet_id":Number(this.outletId),
    "extras": {
      "find": {
      },
      "pagination": false,
      "paginationDetails": {
        "limit": 1,
        "pagesize": 25
      },
      "sorting": true,
      "sortingDetails": {
        "sortfield": "sort_order",
        "sortorder": +1
      }
    }
  }
  this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
    resp => {
      this.allCategories = resp.result.data;
  console.log("categories",this.allCategories)
  if(this.allCategories.length > 0){
    this.allCategories.forEach(element => {
      console.log("element names",element.name)
      let a = document.getElementById(element.name)as HTMLInputElement
      // if(this.configTitle!=="BombayHardware"){
      //   a.classList.remove('active')
      // }
      
      if(element.subcategories!=null&&element.subcategories.length>1)
      {
        element.subcategories.forEach(sub_element => {
          
          let  c=document.getElementById(sub_element.name)as HTMLInputElement
  
          if(this.configTitle!=="Aiema"&& c!=undefined&&c!=null){
            c.classList.remove('active');
        }
        
      });
      }
     
      // if(this.configTitle!=="Aiema" && this.configTitle!=="Cle"){
        if(this.configTitle!=="Aiema" && this.configTitle!=='SriSenbaga'){
      a.classList.remove('active');
    }
    
  });
  
}
});
}


 
        if(this.themesarr.length > 0){
          this.themesarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        
        if(this.brands.length > 0){
        this.brands.forEach(element => {
        let a = document.getElementById(element)as HTMLInputElement
         if(a.checked){
          a.checked = false;
           }
          });         
           }
           if(this.categories.length > 0){
            this.categories.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
             if(a.checked){
              a.checked = false;
               }
              });         
               }
        if(this.pricesarr.length > 0){
          this.pricesarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.agearr.length > 0){

          this.agearr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            // if(a.checked){
            //   a.checked = false;
            // }
          });
          
        }
        if(this.affiliationarr.length > 0){
          this.affiliationarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.standardarr.length > 0){
          this.standardarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.subjectarr.length > 0){
          this.subjectarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.yeararr.length > 0){
          this.yeararr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.featuresarr.length > 0){
          this.featuresarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.finisharr.length > 0){
          this.finisharr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }  
        if(this.sizearr.length > 0){
          this.sizearr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.thicknessarr.length > 0){
          this.thicknessarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
       
        if(this.colorarr.length > 0){
          this.colorarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.typearr.length > 0){
          this.typearr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.materialarr.length > 0){
          this.materialarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        if(this.authorarr.length > 0){
          console.log(this.authorarr,"this.authorarr")
          this.authorarr.forEach(element => {
            let a = document.getElementById(element)as HTMLInputElement
            if(a.checked){
              a.checked = false;
            }
          });
          
        }
        this.brands=[];
        this.categories = [];
        this.themesarr=[];
        this.pricesarr=[];
        this.finisharr=[];
        this.featuresarr=[];
        this.sizearr=[];
        this.thicknessarr=[];
        this.agearr=[];
        this.affiliationarr=[];
        this.subjectarr=[];
        this.yeararr=[];
        this.standardarr=[];
        this.colorarr=[];
        this.typearr=[];
        this.materialarr=[];
        this.authorarr=[];
        
  var queryparams;
  this.route.queryParamMap.subscribe(params => queryparams = params.getAll('terms'));
  if(queryparams[1]!='')
  {
    this.cate=queryparams[1];
    this.categoryname=queryparams[1];
//     this.active='';
//     this.active=this.categoryname;
//   let b = document.getElementById(queryparams[1])as HTMLInputElement
//   b.classList.add('active')
//   console.log(this.categoryname,"this.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categorynamethis.categoryname")
  }
  else{
    // this.subCategory2=[]
    if(this.configTitle=="KatbookStore" && queryparams[1]==''){
        queryparams[1] = []
    }
    else{
    this.subCategory2=[]
  }
  }
  
 
  //category
//  this.localService.set('is_category_filter','true');
//   this.localService.set('category_filter_name','Floral');
// if(this.configTitle==="BombayHardware"){
//   let c = document.getElementById(queryparams[1])as HTMLInputElement
//   console.log("ccccc"+c);
//   if(c!=undefined)
//   {
//     c.classList.add('active')
//   }
// } else {
if(this.configTitle==='BestGifts' || this.configTitle==='BombayHardware'|| this.configTitle==='Cle' || this.configTitle==='Carience' || this.configTitle==='Beaubelle'){
  let b = document.getElementById(this.bestCategory)as HTMLInputElement
  if(b!=undefined)
    {
      console.log("dadatttttttttttttttttttttttttttttttttttttttttttttttttttttt")
      b.classList.add('active')
     console.log("this.activeeeeeee"+this.active)
     
    }
}
else{
  let b = document.getElementById(queryparams[1])as HTMLInputElement
  if(b!=undefined && this.configTitle!=='KatbookStore')
    {
      console.log("dadatttttttttttttttttttttttttttttttttttttttttttttttttttttt")
      b.classList.add('active')
     console.log("this.activeeeeeee"+this.active)
     
    }
}

  

// }

 if(this.filters){
    this.total=this.filters.length;
 }

if(this.configTitle!=='Aiema' && this.configTitle!=='Cle' && this.configTitle!=='BombayHardware' && this.configTitle!=='SpecialWires'&&  this.configTitle!=='Vimpro'){
  // if(this.configTitle=='Beaubelle' ){
  //   let isbrandfilter=false
  //   queryparams[0].forEach(element=>{
  //     let a = document.getElementById(element)as HTMLInputElement
  //     if(a!=undefined)
  //   {
    
    
  //   a.checked=true;
  //   isbrandfilter=true;
  //   if ( this.brands.includes(element) === false) this.brands.push(element);
  //   this.localService.set('isbrandfilter','false')
    
  //   }
  //   })
  //   if(isbrandfilter)
  //   {
  //     let c = document.getElementById('collapseTwo')as HTMLInputElement
  //  //c.classList.remove('collapse')
  //   }

  // }
  
// if(this.configTitle!=='Aiema' && this.configTitle!=='BombayHardware' ){

  // start
  if(this.configTitle!=='Carience'&& this.configTitle!=='Vimpro' && this.configTitle!=='BestGifts'&& this.configTitle!=='Kubendran' && this.configTitle!=='SpecialWires'&& this.configTitle!=='Karupattiraja' && this.configTitle!=='Accel' && this.configTitle!=='BombayHardware' && this.configTitle!=='Beaubelle')
 {   
  if(this.configTitle!=='Deera' && this.configTitle!=='SriSenbaga' && this.configTitle!=='LushNGreen'){
    let isthemefilter=false
    queryparams[3].forEach(element=>{
      let a = document.getElementById(element)as HTMLInputElement
      if(a!=undefined)
    {
    a.checked=true;
    isthemefilter=true;
    if ( this.themesarr.includes(element) === false) this.themesarr.push(element);
    //this.localService.set('is_theme_filter','false')
    
    }
    })
    if(isthemefilter)
    {
      let c = document.getElementById('collapseThree')as HTMLInputElement
  c.classList.remove('collapse')
    }
    // end
  let isfinishfilter=false;
    queryparams[4].forEach(element=>{
      let a = document.getElementById(element)as HTMLInputElement
      if(a!=undefined)
    {
    
    
    a.checked=true;
    isfinishfilter=true;
    if ( this.finisharr.includes(element) === false) this.finisharr.push(element);
    //this.localService.set('is_theme_filter','false')
    
    }
    })
    if(isfinishfilter)
    {
      let c = document.getElementById('collapseFour')as HTMLInputElement
  //c.classList.remove('collapse')
    }
    let isfeaturefilter=false;
  
    queryparams[5].forEach(element=>{
      let a = document.getElementById(element)as HTMLInputElement
      if(a!=undefined)
    {
    
      isfeaturefilter=true;
    a.checked=true;
    if ( this.featuresarr.includes(element) === false) this.featuresarr.push(element);
    //this.localService.set('is_theme_filter','false')
    
    }
    })
    if(isfeaturefilter)
    {
      let c = document.getElementById('collapseFive')as HTMLInputElement
  //c.classList.remove('collapse')
    }
    let ispricefilter=false;
    queryparams[6].forEach(element=>{
      let a = document.getElementById(element)as HTMLInputElement
      if(a!=undefined)
    {
    
    ispricefilter=true;
    a.checked=true;
    if ( this.pricesarr.includes(element) === false) this.pricesarr.push(element);
    //this.localService.set('is_theme_filter','false')
    
    }
    })
    if(ispricefilter)
    {
      let c = document.getElementById('collapseSix')as HTMLInputElement
  //c.classList.remove('collapse')
    }
   
   
  }

    let issizefilter=false;

    if(this.configTitle!=='ShubhCards' && this.configTitle!=='Deera' && this.configTitle!=='SriSenbaga'){
      // console.log("Derrrrrrrraaaaa"+JSON.stringify(queryparams[0]))
      // console.log("Derrrrrrrraaaaa"+JSON.stringify(queryparams[1]))
      // console.log("Derrrrrrrraaaaa"+JSON.stringify(queryparams[2]))
      if(this.configTitle!=='LushNGreen'){
      queryparams[7].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
      
        issizefilter=true;
      a.checked=true;
      if ( this.sizearr.includes(element) === false) this.sizearr.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      if(issizefilter)
      {
        let c = document.getElementById('collapseSeven')as HTMLInputElement
    //c.classList.remove('collapse')
      }
    }
    // this.route.queryParamMap.subscribe((queryParams) => {
    //   const age = queryParams.get('age'); // Check if `age` filter is set
  
    //   if (!age) {
    //     this.ageFilter = ''
    //   } else {

    //     const filters: any = {};
    //     if (age) filters.age = age;
    //     this.ageFilter = age
    //     console.log("ageValue",age,this.ageFilter)
    //   }
    // });
    // this.applyFiltersOnin();
    // let isagefilter=false;
    //  if(this.ageFilter ==''){
    //   console.log("alskdhlashdoi",queryparams[12])
    //   this.ageFilter = []
    //   this.exoticPlants = false
    //     this.indoorPlants = false
    //     this.miniaturePlants = false
    //     this.outdoorPlants = false
    //  }
    // this.ageFilter.forEach(element=>{
    //   let a = document.getElementById(element)as HTMLInputElement
      
    //   if(element == 'Exotic Plants'){
    //     this.exoticPlants = true
    //   }
    //   else if(element == 'Indoor Plants'){
    //     this.indoorPlants = true
    //   }
    //   else if(element == 'Miniature Plants'){
    //     this.miniaturePlants = true
    //   }
    //   else if(element == 'Outdoor Plants'){
    //     this.outdoorPlants = true
    //   }
    //   console.log("element values",element)
    //   if(a!=undefined)
    // {
    //   isagefilter=true;
    // a.checked=true;
    // if ( this.agearr.includes(element) === false) this.agearr.push(element);
  
    
    // }
    // })
    //   if(isagefilter)
    //   {
    //     let c = document.getElementById('collapseTwelve')as HTMLInputElement
    //   }
    }

    let isbrandfilter=false;
    if(this.configTitle!=='ShubhCards' && this.configTitle!=='Deera' && this.configTitle!=='Babys Pride' && this.configTitle!=='SriSenbaga' && this.configTitle!=='LushNGreen'){
      queryparams[0].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        
        if(a!=undefined)
      {
        
        isbrandfilter=true;
      a.checked=true;
      if ( this.brands.includes(element) === false) this.brands.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      if(isbrandfilter) 
      {
        let c = document.getElementById('collapseTwo')as HTMLInputElement
    //c.classList.remove('collapse')
      }
    }
    let iscategoriesfilter=false;
    if(this.configTitle=="KatbookStore"){
      // console.log("branddisplay",queryparams[1])
      queryparams[1].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        
        if(a!=undefined)
      {
        
        iscategoriesfilter=true;
      a.checked=true;
      if ( this.categories.includes(element) === false) this.categories.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      let isaffiliationfilter=false;
      
      queryparams[13].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
        isaffiliationfilter=true;
      a.checked=true;
      if ( this.affiliationarr.includes(element) === false) this.affiliationarr.push(element);
      
      }
      })
      let isstandardfilter=false;
    
      queryparams[14].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
        isstandardfilter=true;
      a.checked=true;
      if ( this.standardarr.includes(element) === false) this.standardarr.push(element);
     
      }
      })
      let issubjectfilter=false;
     
      queryparams[15].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
        issubjectfilter=true;
      a.checked=true;
      if ( this.subjectarr.includes(element) === false) this.subjectarr.push(element);
    
      
      }
      })
      let isyearfilter=false;
    
      queryparams[16].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
        isyearfilter=true;
      a.checked=true;
      if ( this.yeararr.includes(element) === false) this.yeararr.push(element);
     
      
      }
      })
      
    }
    if(this.configTitle!=='ShubhCards' && this.configTitle!=='Deera' && this.configTitle!=='Babys Pride' && this.configTitle!=='BestGifts'&& this.configTitle!=='Kubendran'&& this.configTitle!=='LushNGreen'  && this.configTitle!=='SriSenbaga'){
      let isthicknessfilter=false;
    
      queryparams[8].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
      
        isthicknessfilter=true;
      a.checked=true;
      if ( this.thicknessarr.includes(element) === false) this.thicknessarr.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      if(isthicknessfilter)
      {
        let c = document.getElementById('collapseEight')as HTMLInputElement
    //c.classList.remove('collapse')
      }

    }
    
    let iscolorfilter=false;
    if(this.configTitle!=='ShubhCards' && this.configTitle!=='Deera' && this.configTitle!=='SriSenbaga' && this.configTitle!=='LushNGreen'){
      
      queryparams[9].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
      
        iscolorfilter=true;
      a.checked=true;
      if ( this.colorarr.includes(element) === false) this.colorarr.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      if(iscolorfilter)
      {
        let c = document.getElementById('collapseNine')as HTMLInputElement
    //c.classList.remove('collapse')
      }

      let istypefilter=false;
    
      queryparams[10].forEach(element=>{
        let a = document.getElementById(element)as HTMLInputElement
        if(a!=undefined)
      {
      
        istypefilter=true;
      a.checked=true;
      if ( this.typearr.includes(element) === false) this.typearr.push(element);
      //this.localService.set('is_theme_filter','false')
      
      }
      })
      if(istypefilter)
      {
        let c = document.getElementById('collapseTen')as HTMLInputElement
    //c.classList.remove('collapse')
      }

      
    let ismaterialfilter=false;
    
    queryparams[11].forEach(element=>{
      let a = document.getElementById(element)as HTMLInputElement
      if(a!=undefined)
    {
    
      ismaterialfilter=true;
    a.checked=true;
    if ( this.materialarr.includes(element) === false) this.materialarr.push(element);
    //this.localService.set('is_theme_filter','false')
    
    }
    })
    
    if(ismaterialfilter)
    {
      let c = document.getElementById('collapseEleven')as HTMLInputElement
  //c.classList.remove('collapse')
    }
    
  }
  
    }
  //   if(this.configTitle==='SriSenbaga'){
  //     let isauthorfilter=false;
  //     console.log(queryparams,"queryparams[19]")
    
  //   queryparams[19].forEach(element=>{
  //     let a = document.getElementById(element)as HTMLInputElement
  //     if(a!=undefined)
  //   {
    
  //     isauthorfilter=true;
  //   a.checked=true;
  //   if ( this.authorarr.includes(element) === false) this.authorarr.push(element);
  //   //this.localService.set('is_theme_filter','false')
    
  //   }
  //   }
  // )
    
  //   if(isauthorfilter)
  //   {
  //     let c = document.getElementById('collapseThirteen')as HTMLInputElement
  // //c.classList.remove('collapse')
  //   }
  //   }

}

 
}

  
  public total;
  public collapse: boolean = false;
  public checked: boolean = false;
  public tempArr: any = { "brands": [] };
  // public brands:any = [];
  public stock;
  public cate = [];
  selectedIndex: number = null;
  subCategory1 =[];
  subCategory2=[];
  subCategory3=[];
  subCategory4=[];
  subCategory5=[];
  subCategory6=[];
  subCategory7=[];
  subCategory8=[];
  subCategory9=[];
  subCategory10=[];
  allCategories1: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    // private breadCrumbsService: BreadcrumbsService,
    private productFilterService: ProductFilterService,
    private listingService: ProductListingService,
    public appService:AppService,
    private localService: LocalStorageService,
    private seoService: SEOService
  ) { 
    
  }
  ngOnDestroy()
  {

  }
  ngOnInit(): void {
    if(this.configTitle!=="Deera"){
    this.currentPageUrl = this.getCurrentURL()
    this.seoService.updateCanonicalUrl(this.currentPageUrl);
// if(){
//   this.exoticPlants = false
// }
    if(this.configTitle=="KatbookStore" || this.configTitle=="BabysPride"){
    this.splitRange()
    }
  //   if(this.configTitle=="LushNGreen"){
  //   document.getElementById("collapseTwelve").classList.add("show");
  // }
 
  // Subscribe to query parameters when the component initializes

  this.route.queryParamMap.subscribe((queryParams) => {
    const age = queryParams.getAll('age');  // Get all selected age filters from URL
    if (age.length) {
      this.ageFilter = [];
      age.flatMap(item =>
        
        item.split(',').forEach(str => this.ageFilter.push(str.trim()))
      );
      console.log("do you visit here",this.ageFilter)
    }
    if (age.length > 0) {
      // Set the filter array to the values from URL
      console.log("ageFilter from URL:", age);
      this.applyFiltersOnin(age);
    } else {
      this.ageFilter = [];  // No age filter selected, reset the filter array
      let age1 = []
      this.applyFiltersOnin(age1);
    }

      // Apply the filters to the checkboxes
  });

    console.log("this.prices1.length",this.prices1.length)
    this.active = ""
    this.activeauthor = ""
    window.scrollTo(0,0);
    let testelement = document.getElementById(this.categoryname)as HTMLInputElement    
      if (this.days=='yes') {
       this.values2=true;
      }
      let sliderOne = document.getElementById("slider-1");
    //   if(this.configTitle!=="KatbookStore" && this.configTitle!=="ShubhCards" && this.configTitle!=="Vimpro" && this.configTitle!=="Karupattiraja" && this.configTitle!=="Deera" && this.configTitle!=="SriSenbaga"  && this.configTitle!=="LushNGreen"){
    //   setTimeout(() => {
    //     this.collapseTwelve.nativeElement.classList.remove("show");
    //   }, 2000);
    //   this.clearAll();
    // }
    if(this.configTitle==="ShubhCards"){
      if(this.themesarr!=undefined){
        let c = document.getElementById('collapseThree')as HTMLInputElement
        c.classList.remove('collapse')
      }
    }
    if(this.configTitle==="SriSenbaga"){
      let c = document.getElementById('collapseThirteen')as HTMLInputElement
      this.collapseThirteen.nativeElement.classList.add("show");
    }
     this.outletId = this.appService.outletId;
      
     console.log("outletIdddddddddddddddddddddd"+this.outletId);
     if(this.outletId==1){
       this.outletId = this.localService.get('karupattirajaOutletId');
     }
     if(this.configTitle=="Karupattiraja"){
       if(this.outletId=="0"|| this.outletId==0||this.outletId==""|| this.outletId==null){
         this.outletId=1;
       }
      }
    }
  }

  getAllCategories() {
    let reqData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "outlet_id":Number(this.outletId),
      "extras": {
        "find": {
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 25
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "sort_order",
          "sortorder": +1
        }
      }
    }
    this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
      resp => {

        if(resp.status_code === 200 && resp.success === 1){
          this.allCategories = resp.result.data;
          this.active = "";
          if(this.configTitle==="BombayHardware"||this.configTitle==="SpecialWires"|| this.configTitle==="Beaubelle" || this.configTitle==="Vimpro"){
            //  this.active = this.categoryname1
            // this.active = 'Pipes'
            
            if(this.allCategories.length > 1){
              //FIRST LEVEL SUBCATEGORY
              // this.active = this.categoryValue;
              // this.testValue = this.categoryValue;
              for(let i =0;i<this.allCategories.length;i++){
                // if(this.allCategories[i].name == 'Pipes'){
                  if(this.allCategories[i].name === this.parentCategory){
                    // if(this.allCategories[i].name === this.categoryname1){
                  this.categoryName='';
                  if(this.allCategories[i].subcategories!==undefined){
                    this.categoryName=this.allCategories[i].name;
                    this.subCategory2 = this.subCategory1.concat(this.allCategories[i].subcategories);
                    console.log("sub cate",  this.subCategory2 )
                  }
                }                
              }
            }
          }
        }
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
  }
  applyFiltersOnin(age){
    this.exoticPlants = false;
    this.indoorPlants = false;
    this.miniaturePlants = false;
    this.outdoorPlants = false;
    console.log(age)
    if(age.length > 0){
  // Loop through the ageFilter and update the checkbox states based on URL
  let processedResult = age[0].split(',').map((item, index) => {
      let checkbox = document.getElementById(item) as HTMLInputElement;
      console.log("item list of age",item)
      // Update individual plant filter states based on the URL
      if (item === 'Exotic-Plants') {
        this.exoticPlants = true;
      } else if (item === 'Indoor-Plants') {
        this.indoorPlants = true;
      } else if (item === 'Miniature-Plants') {
        this.miniaturePlants = true;
      } else if (item === 'Outdoor-Plants') {
        this.outdoorPlants = true;
      }
    });
  }
  }
  applyFilters() {
    // Reset all filter states (checkboxes) to false
    this.exoticPlants = false;
    this.indoorPlants = false;
    this.miniaturePlants = false;
    this.outdoorPlants = false;
console.log("Test for Filter elements",this.ageFilter)
if(this.ageFilter.length > 0){
let processedResult = this.ageFilter[0].split(',').map((item, index) => {
  console.log("processedResult",item)
  let checkbox = document.getElementById(item) as HTMLInputElement;
  if (item === 'Exotic-Plants') {
    this.exoticPlants = true;
  } else if (item === 'Indoor-Plants') {
    this.indoorPlants = true;
  } else if (item === 'Miniature-Plants') {
    this.miniaturePlants = true;
  } else if (item === 'Outdoor-Plants') {
    this.outdoorPlants = true;
  }

  // Check if the checkbox is available and update the checkbox as checked
  if (checkbox) {
    checkbox.checked = true;
    // Add the element to the agearr if it's not already present
  }
});
}
    // Loop through the ageFilter and update the checkbox states based on URL
    // this.ageFilter.forEach((element) => {
    //   let checkbox = document.getElementById(element) as HTMLInputElement;

      // Update individual plant filter states based on the URL
      // if (element === 'Exotic Plants') {
      //   this.exoticPlants = true;
      // } else if (element === 'Indoor Plants') {
      //   this.indoorPlants = true;
      // } else if (element === 'Miniature Plants') {
      //   this.miniaturePlants = true;
      // } else if (element === 'Outdoor Plants') {
      //   this.outdoorPlants = true;
      // }

      // Check if the checkbox is available and update the checkbox as checked
      // if (checkbox) {
      //   checkbox.checked = true;
        // Add the element to the agearr if it's not already present
    //     if (!this.agearr.includes(element)) {
    //       this.agearr.push(element);
    //     }
    //   }
    // });
  }
  brands=[];
  appliedFilter(values:any,facet) {
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      if ( this.brands.includes(facet.name) === false) this.brands.push(facet.name);
      console.log("BOMBAY1111111111111111111111")
      this.callListingScreen()
     
    }else{
     for(var i =0;i<this.brands.length;i++){
       if(this.brands[i]==facet.name){
        this.brands.splice(i,1);
       }
     }
     console.log("BOMBAY1111111111111111111111")
     this.callListingScreen()
     
    }
    console.log(facet.label);
   
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
 
  }
  appliedFilterKat(values:any,facet) {
  console.log("bransshow", this.filters)
  let a = document.getElementById("checkmedium")as HTMLInputElement
  a.checked = false;
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      if ( this.brands.includes(facet.name) === false) this.brands.push(facet.name);
this.active = "Yes"
      this.callListingScreen()
      this.brandstore = this.brands
    }else{
     for(var i =0;i<this.brands.length;i++){
       if(this.brands[i]==facet.name){
        this.brands.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  appliedAllBFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checkmedium")as HTMLInputElement
      a.checked = true;
      console.log(this.brandstore)
      this.brandstore.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      this.active = "dontcheck"
      })
      this.brands = [];
this.brandoptions = true;

      this.callListingScreen()
     
    }else{
      let a = document.getElementById("checkmedium")as HTMLInputElement
      a.checked = false;
    }
  }
  appliedAllCFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checkinst")as HTMLInputElement
      a.checked = true;
      console.log(this.categorystore)
      this.categorystore.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      this.active = "dontcheck"
      console.log("Test for coming in")
      })
      this.catsted = [];
this.brandoptions = true;

      this.callListingScreen()
      
    }else{
      let a = document.getElementById("checkinst")as HTMLInputElement
      a.checked = false;
    }
  }
  appliedAllAffFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checkaff")as HTMLInputElement
      a.checked = true;
      console.log(this.affiliationarr)
      this.affiliationarr.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      this.active = "dontcheck"
      })
      this.affiliationarr=[]
      // this.catsted = [];
this.brandoptions = true;

      this.callListingScreen()
      
    }else{
      let a = document.getElementById("checkaff")as HTMLInputElement
      a.checked = false;
    }
  }
  appliedAllSubjFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checksubj")as HTMLInputElement
      a.checked = true;
      console.log(this.subjectarr)
      this.subjectarr.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      this.active = "dontcheck"
      })
      this.subjectarr=[]
      // this.catsted = [];
this.brandoptions = true;

      this.callListingScreen()
      
    }else{
      let a = document.getElementById("checksubj")as HTMLInputElement
      a.checked = false;
    }
  }
  appliedAllYeaFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checkyear")as HTMLInputElement
      a.checked = true;
      console.log(this.yeararr)
      this.yeararr.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      this.active = "dontcheck"
      })
      this.yeararr=[]
      // this.catsted = [];
this.brandoptions = true;

      this.callListingScreen()
      
    }else{
      let a = document.getElementById("checkyear")as HTMLInputElement
      a.checked = false;
    }
  }
  appliedAllStanFilter(values:any){
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      let a = document.getElementById("checkstan")as HTMLInputElement
      a.checked = true;
      console.log(this.standardarr)
      this.standardarr.forEach(element => {
let c = document.getElementById(element)as HTMLInputElement
      c.checked = false;
      })
      this.standardarr=[]
      // this.catsted = [];
this.brandoptions = true;

      this.callListingScreen()
      this.active = "dontcheck"
    }else{
      let a = document.getElementById("checkstan")as HTMLInputElement
      a.checked = false;
    }
  }
  categories=[];
  appliedFilterCategories(values:any,facet) {
  console.log("catsshow", this.categoriesList)
  let a = document.getElementById("checkinst")as HTMLInputElement
  a.checked = false;
  console.log("console for filter checked",a.checked)
    this.value = values.currentTarget.checked;
    if(this.value==true){
      // this.brands.push(facet.name);
      if ( this.catsted.includes(facet.name) === false) this.catsted.push(facet.name);
      console.log("Testfor categorylist",this.catsted)
      this.callListingScreen()
      this.categorystore = this.catsted
    }else{
     for(var i =0;i<this.catsted.length;i++){
       if(this.catsted[i]==facet.name){
        console.log("Test for catli")
        this.catsted.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    this.active = "Yes"
    console.log(facet.name);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  affiliationarr=[];
  appliedFilterAffiliation(values:any,facet) {
    console.log("affiliationshow", this.affiliation)
    let a = document.getElementById("checkaff")as HTMLInputElement
  a.checked = false;
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.affiliationarr.includes(facet.name) === false) this.affiliationarr.push(facet.name);
      this.callListingScreen()
      this.active = "Yes"
    }else{
     for(var i =0;i<this.affiliationarr.length;i++){
       if(this.affiliationarr[i]==facet.name){
        this.affiliationarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  standardarr=[];
  appliedFilterStandard(values:any,facet) {
    console.log("standardshow", this.standard)
    let a = document.getElementById("checkstan")as HTMLInputElement
  a.checked = false;
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.standardarr.includes(facet.name) === false) this.standardarr.push(facet.name);
      this.callListingScreen()
      this.active = "Yes"
    }else{
     for(var i =0;i<this.standardarr.length;i++){
       if(this.standardarr[i]==facet.name){
        this.standardarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  subjectarr=[];
  appliedFilterSubject(values:any,facet) {
    console.log("subjectshow", this.subject)
    let a = document.getElementById("checksubj")as HTMLInputElement
  a.checked = false;
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.subjectarr.includes(facet.name) === false) this.subjectarr.push(facet.name);
      this.callListingScreen()
      this.active = "Yes"
    }else{
     for(var i =0;i<this.subjectarr.length;i++){
       if(this.subjectarr[i]==facet.name){
        this.subjectarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  yeararr=[];
  appliedFilterYear(values:any,facet) {
    console.log("yearshow", this.year)
    let a = document.getElementById("checkyear")as HTMLInputElement
  a.checked = false;
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.yeararr.includes(facet.name) === false) this.yeararr.push(facet.name);
      this.callListingScreen()
      this.active = "Yes"
    }else{
     for(var i =0;i<this.yeararr.length;i++){
       if(this.yeararr[i]==facet.name){
        this.yeararr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  themesarr=[];
  appliedFilterTheme(values:any,facet)  {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.themesarr.includes(facet.name) === false) this.themesarr.push(facet.name);
      //this.themesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.themesarr.length;i++){
       if(this.themesarr[i]==facet.name){
        this.themesarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  finisharr=[];
  appliedFilterFinish(values:any,facet) {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.finisharr.includes(facet.name) === false) this.finisharr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.finisharr.length;i++){
       if(this.finisharr[i]==facet.name){
        this.finisharr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  appliedFilterKat1(values:any,facet) {
    console.log("bransshow", this.filters)
    let a = document.getElementById("checkmedium1")as HTMLInputElement
    a.checked = false;
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        if ( this.brands.includes(facet.name) === false) this.brands.push(facet.name);
  
        this.callListingScreen()
        this.brandstore = this.brands
      }else{
       for(var i =0;i<this.brands.length;i++){
         if(this.brands[i]==facet.name){
          this.brands.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.label);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
    appliedAllBFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checkmedium1")as HTMLInputElement
        a.checked = true;
        console.log(this.brandstore)
        this.brandstore.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        })
        this.brands = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checkmedium1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedAllCFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checkinst1")as HTMLInputElement
        a.checked = true;
        console.log(this.categorystore)
        this.categorystore.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        console.log("Test for coming in")
        })
        this.catsted = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checkinst1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedAllAffFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checkaff1")as HTMLInputElement
        a.checked = true;
        console.log(this.affiliationarr)
        this.affiliationarr.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        })
        this.affiliationarr=[]
        // this.catsted = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checkaff1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedAllSubjFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checksubj1")as HTMLInputElement
        a.checked = true;
        console.log(this.subjectarr)
        this.subjectarr.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        })
        this.subjectarr=[]
        // this.catsted = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checksubj1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedAllYeaFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checkyear1")as HTMLInputElement
        a.checked = true;
        console.log(this.yeararr)
        this.yeararr.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        })
        this.yeararr=[]
        // this.catsted = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checkyear1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedAllStanFilter1(values:any){
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        let a = document.getElementById("checkstan1")as HTMLInputElement
        a.checked = true;
        console.log(this.standardarr)
        this.standardarr.forEach(element => {
  let c = document.getElementById(element)as HTMLInputElement
        c.checked = false;
        })
        this.standardarr=[]
        // this.catsted = [];
  this.brandoptions = true;
  
        this.callListingScreen()
        
      }else{
        let a = document.getElementById("checkstan1")as HTMLInputElement
        a.checked = false;
      }
    }
    appliedFilterCategories1(values:any,facet) {
    console.log("catsshow", this.categoriesList)
    let a = document.getElementById("checkinst1")as HTMLInputElement
    a.checked = false;
    console.log("console for filter checked",a.checked)
      this.value = values.currentTarget.checked;
      if(this.value==true){
        // this.brands.push(facet.name);
        if ( this.catsted.includes(facet.name) === false) this.catsted.push(facet.name);
        console.log("Testfor categorylist",this.catsted)
        this.callListingScreen()
        this.categorystore = this.catsted
      }else{
       for(var i =0;i<this.catsted.length;i++){
         if(this.catsted[i]==facet.name){
          console.log("Test for catli")
          this.catsted.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.name);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
    appliedFilterAffiliation1(values:any,facet) {
      console.log("affiliationshow", this.affiliation)
      let a = document.getElementById("checkaff1")as HTMLInputElement
    a.checked = false;
      console.log(values.currentTarget.checked);
      this.value = values.currentTarget.checked;
      if(this.value==true){
        if ( this.affiliationarr.includes(facet.name) === false) this.affiliationarr.push(facet.name);
        this.callListingScreen()
        
      }else{
       for(var i =0;i<this.affiliationarr.length;i++){
         if(this.affiliationarr[i]==facet.name){
          this.affiliationarr.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.label);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
    appliedFilterStandard1(values:any,facet) {
      console.log("standardshow", this.standard)
      let a = document.getElementById("checkstan1")as HTMLInputElement
    a.checked = false;
      console.log(values.currentTarget.checked);
      this.value = values.currentTarget.checked;
      if(this.value==true){
        if ( this.standardarr.includes(facet.name) === false) this.standardarr.push(facet.name);
        this.callListingScreen()
        
      }else{
       for(var i =0;i<this.standardarr.length;i++){
         if(this.standardarr[i]==facet.name){
          this.standardarr.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.label);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
    appliedFilterSubject1(values:any,facet) {
      console.log("subjectshow", this.subject)
      let a = document.getElementById("checksubj1")as HTMLInputElement
    a.checked = false;
      console.log(values.currentTarget.checked);
      this.value = values.currentTarget.checked;
      if(this.value==true){
        if ( this.subjectarr.includes(facet.name) === false) this.subjectarr.push(facet.name);
        this.callListingScreen()
        
      }else{
       for(var i =0;i<this.subjectarr.length;i++){
         if(this.subjectarr[i]==facet.name){
          this.subjectarr.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.label);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
    appliedFilterYear1(values:any,facet) {
      console.log("yearshow", this.year)
      let a = document.getElementById("checkyear1")as HTMLInputElement
    a.checked = false;
      console.log(values.currentTarget.checked);
      this.value = values.currentTarget.checked;
      if(this.value==true){
        if ( this.yeararr.includes(facet.name) === false) this.yeararr.push(facet.name);
        this.callListingScreen()
        
      }else{
       for(var i =0;i<this.yeararr.length;i++){
         if(this.yeararr[i]==facet.name){
          this.yeararr.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
      console.log(facet.label);
      
      // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });
  
    }
  featuresarr=[];
  appliedFilterFeature(values:any,facet) {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.featuresarr.includes(facet.name) === false) this.featuresarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.featuresarr.length;i++){
       if(this.featuresarr[i]==facet.name){
        this.featuresarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  pricesarr=[];
  appliedFilterPrice(values:any,facet) {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.pricesarr.includes(facet.name) === false) this.pricesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.pricesarr.length;i++){
       if(this.pricesarr[i]==facet.name){
        this.pricesarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  agearr=[];
  appliedFilterAge(values: any, facet) {
    console.log("filter age")

    this.value = values.currentTarget.checked;
    console.log("Filter for Age",this.ageFilter,facet)

    if (this.value) {
      // Add filter only if it's not already present
      // if (!this.ageFilter.some((item) => item === facet)) {
      //   this.ageFilter.push(facet);
      // }
      if ( this.ageFilter.includes(facet) === false) {
        this.ageEncode= facet.replace(/ /g, '-');
        this.ageFilter.push(this.ageEncode)
        this.applyFilters();
      };
    } else {
      // Remove filter by name
      this.ageEncode= facet.replace(/ /g, '-');
      this.ageFilter = this.ageFilter.filter((item) => item !== this.ageEncode);
      this.applyFilters();
    }
  
    
  this.updateURL();
  }
  authorarr=[];
  appliedFilterAuthor(values:any,facet) {
    console.log("authornshow", this.author)
    this.activeauthor = facet
    this.value = true;
    if(this.value==true){
      if ( this.authorarr.includes(facet) === false) this.authorarr.push(facet);
      console.log("id value",facet)
      this.updateAuthor()
      this.activeauthor = facet
    }else{
     for(var i =0;i<this.authorarr.length;i++){
       if(this.authorarr[i]==facet){
        this.authorarr.splice(i,1);
       }
     }
     this.updateAuthor()
      
    }

    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  sizearr=[];
  appliedFilterSize(values:any,facet)  {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.sizearr.includes(facet.name) === false) this.sizearr.push(facet.name);
      //this.themesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.sizearr.length;i++){
       if(this.sizearr[i]==facet.name){
        this.sizearr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }

  thicknessarr=[];
  appliedFilterThickness(values:any,facet)  {
    console.log(values.currentTarget.checked);
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.thicknessarr.includes(facet.name) === false) this.thicknessarr.push(facet.name);
      //this.themesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.thicknessarr.length;i++){
       if(this.thicknessarr[i]==facet.name){
        this.thicknessarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }
  
  colorarr=[];
  appliedFilterColor(values:any,facet)  {
    if(this.configTitle!== 'Deera'){
    console.log("colorrrrr"+values.currentTarget.checked);
    console.log("color"+facet.name);
      this.value = values.currentTarget.checked;
      if(this.value==true){
        if ( this.colorarr.includes(facet.name) === false) this.colorarr.push(facet.name);
        //this.themesarr.push(facet.name);
        this.callListingScreen()
        
      }else{
       for(var i =0;i<this.colorarr.length;i++){
         if(this.colorarr[i]==facet.name){
          this.colorarr.splice(i,1);
         }
       }
       this.callListingScreen()
        
      }
    } 
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }


  appliedDeeraColor(data){
    this.active2="";
    this.deeracolor=[];
    this.deeradimension=[];
    this.active2=data;
    if(this.configTitle=== 'Deera'){
      console.log("facettttttttttt"+data)
      this.deeracolor.push(data)
      this.callListingScreen()
    }
  }

  appliedDeeraColor1(data){
    // this.deeracolor=[];
  }

  appliedDeeraDimension(data1){
    this.deeradimension=[];
    if(this.configTitle=== 'Deera'){
      console.log("facettttttttttt"+data1)
      this.deeradimension.push(data1)
      this.callListingScreen()
    }
  }



  typearr=[];
  appliedFilterType(values:any,facet)  {
   
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.typearr.includes(facet.name) === false) this.typearr.push(facet.name);
      //this.themesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.typearr.length;i++){
       if(this.typearr[i]==facet.name){
        this.typearr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }

  materialarr=[];
  appliedFilterMaterial(values:any,facet)  {
    this.value = values.currentTarget.checked;
    if(this.value==true){
      if ( this.materialarr.includes(facet.name) === false) this.materialarr.push(facet.name);
      //this.themesarr.push(facet.name);
      this.callListingScreen()
      
    }else{
     for(var i =0;i<this.materialarr.length;i++){
       if(this.materialarr[i]==facet.name){
        this.materialarr.splice(i,1);
       }
     }
     this.callListingScreen()
      
    }
    console.log(facet.label);
    
    // this.router.navigate([`/listing`], {queryParams: { terms:this.brands, type:'brandValue' }, relativeTo:this.route,  skipLocationChange: false });

  }

  onChange(values:any,name):void {
    console.log(values.currentTarget.checked);
    this.stock = values.currentTarget.checked;
    if(this.stock==true){
      if(name=='Last 90 days'){
        this.stockDetails.push(name);
        if(this.stockDetails.length > 1){
          for(let i =0;i<this.stockDetails.length;i++){
            if(this.stockDetails[i]=='Last 30 days'){
              this.stockDetails.splice(i,1)
            }
          }
        }
      }else if(name == 'Last 30 days'){
        this.stockDetails.push(name);
        if(this.stockDetails.length > 1){
          for(let i =0;i<this.stockDetails.length;i++){
            if(this.stockDetails[i]=='Last 90 days'){
              this.stockDetails.splice(i,1)
            }
          }
          // this.stockDetails.forEach(element => {
          //   if(element == 'Last 90 days')
          //   this.stockDetails.splice(element)
          // });
        }
      }else{
        this.stockDetails.push(name);
      }
      
      this.callListingScreen()
    }else{
      for(var i =0;i<this.stockDetails.length;i++){
        if(this.stockDetails[i]==name){
         this.stockDetails.splice(i,1);
        }
      }
      this.callListingScreen()
       
    }
   
    
  }
  

  openContent() {
    this.collapse = !this.collapse;
    this.checked = true;
  }


  updateFilter(event){

  }

  checkedevt(values:any, name){

    this.intialVal = false;
    this.active = name;
 
   this.cate=[name]
   console.log("in set data***1"+this.cate);
   this.callListingScreen()
  }

  checkedevt1(values:any, name){
    this.intialVal = false;
    this.active = '';
    console.log(name,"name")
    this.active = name;
    this.activeauthor = ""
    this.listingService.updateAdminFormEvent({
      name:"categoryName",
      value: name
      
    })
    let reqData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "outlet_id":Number(this.outletId),
      "extras": {
        "find": {
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 25
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "sort_order",
          "sortorder": -1
        }
      }
    }
    this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
      resp => {
        console.log("1")
        console.log("gatttttttttttttttttttttttttt")
        this.allCategories1 = resp.result.data;
        if(this.configTitle=== 'Babys Pride'){
          this.listingService.updateAdminFormEvent({
            name:"categorySEOData",
            value: resp.result.data 
          })   
        }
        this.subCategory = '';
        if(this.allCategories1.length >= 1){
          console.log("12")
          //FIRST LEVEL SUBCATEGORY
          for(let i =0;i<this.allCategories1.length;i++){
            if(this.allCategories1[i].name == name){
              this.categoryName='';
              // for(let i =0;i<this.allCategories1[i].length;i++){
              if(this.allCategories1[i].subcategories!==undefined){
                this.categoryName=this.allCategories1[i].name;
                // this.listingService.updateAdminFormEvent({
                //   name:"categoryName",
                //   value: this.categoryName
                  
                // })
                this.subCategory2 = this.subCategory1.concat(this.allCategories1[i].subcategories);
                console.log(this.subCategory2,'this.subCategory2')
              }
            }
            //SECOND LEVEL SUBCATEGORY
              for(let i =0;i<this.subCategory2.length;i++){
                if(this.subCategory2[i].name == name){
                   this.categoryName1='';
                   if(this.subCategory2[i].subcategories!==undefined){
                  
                    this.categoryName1=this.subCategory2[i].name;
                  
                    this.subCategory4 = this.subCategory3.concat(this.subCategory2[i].subcategories);
                  }
                }
                //THIRD LEVEL SUBCATEGORY
                for(let i =0;i<this.subCategory4.length;i++){
                  if(this.subCategory4[i].name == name){
                    this.categoryName2='';
                    if(this.subCategory4[i].subcategories!==undefined){
                    
                      this.categoryName2=this.subCategory4[i].name;
                      this.subCategory6 = this.subCategory5.concat(this.subCategory4[i].subcategories);
                    }
                  }
                   //FOURTH LEVEL SUBCATEGORY
                  for(let i =0;i<this.subCategory6.length;i++){
                    if(this.subCategory6[i].name == name){
                      this.categoryName3='';
                      if(this.subCategory6[i].subcategories!==undefined){
                        this.categoryName3=this.subCategory6[i].name;
                        this.subCategory8 = this.subCategory7.concat(this.subCategory6[i].subcategories);
                      }
                    }
                    //FIFTH LEVEL SUBCATEGORY
                    for(let i =0;i<this.subCategory8.length;i++){
                      if(this.subCategory8[i].name == name){
                        this.categoryName4='';
                        // if(this.subCategory8[i].subcategories!==undefined){
                          this.categoryName4=this.subCategory8[i].name;
                          this.subCategory10 = this.subCategory9.concat(this.subCategory8[i].subcategories);
                        // }
                      }
                    }
                  } 

                }
              }
              // }
            
          }
        }
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
   this.cate=[name]
   if(this.configTitle=== 'Babys Pride'){
    this.router.navigate([`/productListing`], {queryParams: { terms:[[],[this.cate],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

   }
   else if(this.configTitle=== 'BestGifts' || this.configTitle==='BombayHardware' || this.configTitle==='SriSenbaga' || this.configTitle==='Karupattiraja'|| this.configTitle==='Cle' || this.configTitle==='Carience'){
    const params = name.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
   }
   else if(this.configTitle=== 'Deera'){
    this.router.navigate([`/productListing`], {queryParams: { terms:[[],[this.cate],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

   }
   else if (this.configTitle==="SpecialWires" || this.configTitle==='Aiema'){ 
    this.router.navigate([`/productListing`], {queryParams: { terms:[[],[this.cate],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
   }
   else if(this.configTitle=== 'Beaubelle'){
    console.log(this.brands,'rwty')
    this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[this.cate],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
   }
   
  //  else if ( this.configTitle=== 'Beaubelle'){
  //   this.router.navigate(['/']).then(()=>
  //   this.router.navigate([`/productListing`], {queryParams: { terms:[[],[this.cate],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false }));

  //  }
    else {
    this.callListingScreen()
   }
   
  }

callListingScreen(){

this.allData=[{
  brand:this.brands,
  
  
  categories1:this.cate,


  stock:this.stockDetails,

}
  
]
// if(this.configTitle=="Beaubelle"){
//   this.router.navigate(['/']).then(()=>
//   this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[],[this.stockDetails],[this.themesarr],[this.finisharr],[this.featuresarr],[this.pricesarr],[this.sizearr],[this.thicknessarr],[this.colorarr],[this.typearr],[this.materialarr]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false }));
if(this.configTitle!== 'Babys Pride' && this.configTitle!== 'KatbookStore' && this.configTitle!== 'Deera'){
  
this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[this.cate],[this.stockDetails],[this.themesarr],[this.finisharr],[this.featuresarr],[this.pricesarr],[this.sizearr],[this.thicknessarr],[this.colorarr],[this.typearr],[this.materialarr],[this.agearr],[this.affiliationarr],[this.standardarr],[this.subjectarr],[this.yeararr],[this.subRanges],[this.deeradimension],[this.authorarr]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
}
else if(this.configTitle == 'KatbookStore'){
  console.log("calledforreload",JSON.stringify(this.brands),JSON.stringify(this.categories))
  // console.log("Test for catarr",this.categarr)
  // window.location.reload();
   this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[this.catsted],[this.stockDetails],[this.themesarr],[this.finisharr],[this.featuresarr],[this.pricesarr],[this.sizearr],[this.thicknessarr],[this.colorarr],[this.typearr],[this.materialarr],[this.agearr],[this.affiliationarr],[this.standardarr],[this.subjectarr],[this.yeararr],[this.subRanges],[this.deeradimension],[this.authorarr]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
} else if(this.configTitle=== 'Deera'){
  console.log("nbnbnb",JSON.stringify(this.deeracolor))
  console.log("nbnbnb",JSON.stringify(this.deeradimension))
  this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[this.cate],[this.stockDetails],[this.themesarr],[this.finisharr],[this.featuresarr],[this.pricesarr],[this.sizearr],[this.thicknessarr],[this.deeracolor],[this.typearr],[this.materialarr],[this.agearr],[this.affiliationarr],[this.standardarr],[this.subjectarr],[this.yeararr],[this.subRanges],[this.deeradimension],[this.authorarr]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

}
else{
  // this.router.navigate([`/productListing`], {queryParams: { terms:[[this.brands],[this.cate],[this.stockDetails],[this.themesarr],[this.finisharr],[this.featuresarr],[this.subRanges],[this.sizearr],[this.thicknessarr],[this.colorarr],[this.typearr],[this.materialarr],[this.agearr],[this.affiliationarr],[this.standardarr],[this.subjectarr],[this.yeararr],[this.subRanges]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
}
}

clearCheckBox(){
  
  let a = document.getElementById('day90')as HTMLInputElement
      if(a.checked){
        a.checked = false;
      }
      let b = document.getElementById('day30')as HTMLInputElement
      if(b.checked){
        b.checked = false;
      }
      let c = document.getElementById('outOfStock')as HTMLInputElement
      if(c.checked){
        c.checked = false;
      }
    
}
check90Days(){
  let a = document.getElementById('day90')as HTMLInputElement
 
   a.checked=true;
  this.stockDetails.push('Last 90 days');
}
toggle(e: HTMLElement) {
  e.classList.toggle('hidden');
}
changeCheckecd(values:any,name){
  console.log(values.currentTarget.checked);
  this.value = values.currentTarget.checked;
  if(this.value == true){
    if(name == 'Last 90 days'){
      let c = document.getElementById('day30')as HTMLInputElement
     
        c.checked = false;
     // }
    }else{
      let b = document.getElementById('day90')as HTMLInputElement
     
        b.checked = false;
    }
   
   
   
  }
 

}

setIndex(index: number) {
  this.selectedIndex = index;
}
toggleCollapse() {
  console.log("Expanded Or nhdfh",this.isExpanded)
  this.isExpanded = !this.isExpanded;
}
clearBest(){

  this.router.navigate(['/productListing']);
}
clearAll(){
  console.log("123")
  if(this.configTitle!== 'LushNGreen'){
  this.cate=[];
}
  this.categories = [];
   this.brands=[];
   this.catsted = [];
   this.themesarr=[];
   this.pricesarr=[];
   this.featuresarr=[];
   this.finisharr=[];
   this.sizearr=[];
   this.thicknessarr=[];
   this.agearr=[];
   this.affiliationarr=[];
   this.authorarr=[];
   this.subjectarr=[];
   this.yeararr=[];
   this.standardarr=[];
   this.colorarr=[];
   this.typearr=[];
   this.exoticPlants = false
   this.indoorPlants = false
   this.miniaturePlants = false
   this.outdoorPlants = false
   this.clearPlant = false
   this.materialarr=[];
   this.selectedRange  = { min: this.prices1[0], max: this.prices1[13] };
   this.selectedRange1  = { min: this.prices2[0], max: this.prices2[10] };
   this.subRanges=[];
   this.stockDetails=[];
   if(this.configTitle=== 'BombayHardware'||this.configTitle=== 'Vimpro'|| this.configTitle=== 'Beaubelle' || this.configTitle=== 'Schift Cosmetics'  || this.configTitle=== 'Aiema' || this.configTitle=== 'Cle' || this.configTitle=== 'SpecialWires' || this.configTitle=== 'Babys Pride' || this.configTitle=== 'SriSenbaga' ){
    this.categoryName="";
    this.categoryName1="";
    this.categoryName2="";
    this.categoryName3="";
    this.categoryName4="";
   }
  //   for(let i =0;i < this.filters.length;i++){
  //     this.filters[i].value = false; 
  // }
  this.values1 = false;
  this.values2 = false;
  this.values3 = false;
  
// CLEAR ALL EVENT
this.listingService.updateAdminFormEvent('clearAll');
if(this.configTitle=== 'Babys Pride' ){
  this.collapseTwelve.nativeElement.classList.remove("show");

}

// this.breadCrumbsService.updateAdminFormEvent('');
this.activeauthor = '';
this.active = '';
// if(this.configTitle=== 'Aiema' || this.configTitle=== 'BombayHardware'){
  if(this.configTitle=== 'Aiema' ){
    // this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    // this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    this.router.navigate([`/productListing`], { queryParams: { terms:'',type: 'last90days' }, relativeTo: this.route, skipLocationChange: false });
  }
// console.log("affiliationarrlook",this.affiliationarr)
if(this.configTitle=== 'BombayHardware' ||this.configTitle==="SpecialWires" || this.configTitle=== 'Cle' || this.configTitle=== 'Babys Pride' || this.configTitle=== 'SriSenbaga'){
  console.log("success rate to be calculated")
  this.active="";
  this.activeauthor="";
  this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
  }
  if(this.configTitle=== 'LushNGreen'){
    console.log("success rate to be calculated")
    this.active="";
    this.activeauthor="";
    const params = "/Plants";
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing/Plants']);
    }
    if(this.configTitle=== 'SriSenbaga'){
      this.active="";
    this.activeauthor="";
    this.router.navigate(['/productListing']);
    }
if(this.configTitle=== 'ShubhCards' || this.configTitle==='BestGifts'||this.configTitle=== 'Beaubelle' ||this.configTitle=== 'Schift Cosmetics'||this.configTitle=== 'Carience'||this.configTitle=== 'Vimpro'||this.configTitle=== 'Kubendran'||this.configTitle=== 'Karupattiraja'||this.configTitle=== 'KatbookStore'){
this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
}
if(this.configTitle=== 'Deera'){
  console.log("daaaaaaaaa")
this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });

}
if(this.configTitle=== 'KatbookStore'){
  let a = document.getElementById("checkmedium")as HTMLInputElement
  a.checked = true;

let b = document.getElementById("checkinst")as HTMLInputElement
   b.checked = true;

let c = document.getElementById("checksubj")as HTMLInputElement
   c.checked = true;

let d = document.getElementById("checkyear")as HTMLInputElement
   d.checked = true;

let e = document.getElementById("checkstan")as HTMLInputElement
   e.checked = true;
   
}
}
// clearAllBaby(){
//   this.clearAll()
// }
brandListing(brandName) {
  this.router.navigate(['/']).then(()=>
  this.router.navigate([`/productListing`], { queryParams: { terms: [brandName], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false }));
  //this.router.navigate([`/productListing`], { queryParams: { terms: ['Beaubelle'], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
}
callListingLush(){
    if (this.agearr.length > 0) {
      // Update the URL to include the selected age filters as query parameters
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { age: this.agearr },
        queryParamsHandling: 'merge', // Merge with any existing query params
      });
    } else {
      // If no age filters are selected, remove the age query param from the URL
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { age: null },
        queryParamsHandling: 'merge', // Merge with other query params
      });
    }
  
}
updateURL() {
  // Update the URL when filters change
  const ageQuery = this.ageFilter.join(','); // Join the selected filters as a comma-separated string
  this.router.navigate([], {
    queryParams: { age: ageQuery },
    queryParamsHandling: 'merge', // Merge with existing query params
  });
}
updateAuthor() {
  const currentParams = this.route.snapshot.queryParams;
  const currentRoute = this.route.snapshot.url.map(segment => segment.path).join('/');
  const encodedAuthor = this.authorarr[0].replace(/ /g, '-');
  console.log("authorArr", encodedAuthor, currentParams, currentRoute);
  if(currentRoute=="productListing"){ 
    this.router.navigate([], { // Use backticks for template literals
      queryParams: { author: encodedAuthor }, // Add query parameter for author
      queryParamsHandling: 'merge', // Merge with existing query params
    });
  }
  else{
  this.router.navigate([`/productListing/${currentRoute}`], { // Use backticks for template literals
    queryParams: { author: encodedAuthor }, // Add query parameter for author
    queryParamsHandling: 'merge', // Merge with existing query params
    
  });
}
}
splitRange() {
  const [start, end] = this.originalRange.split('-').map(Number);
  this.subRanges = [];
  for (let i = start; i < end; i += 50) {
    const subrangeStart = i;
    const subrangeEnd = i + 50;
    const subrange = `${subrangeStart}-${subrangeEnd}`;
    this.subRanges.push(subrange);
    console.log("subRanges",JSON.stringify(this.subRanges))
  }
  this.callListingScreen()

}
refreshwindow(){
  window.location.reload()
}
scrollchange(){
  this.slideOne();
  this.slideTwo();
  this.originalRange = this.selectedRange.min + '-' + this.selectedRange.max
  this.splitRange();
}


slideOne(){
  if(this.selectedRange.min == 650){
  if(this.selectedRange.max-parseInt(this.selectedRange.min)<= this.minGap){
    this.selectedRange.min=parseInt(this.selectedRange.max) - this.minGap;
    
  }
}
}
slideTwo(){
  if(this.selectedRange.min !== 650){
    // this.inputValue1.addEventListener("input",this.listener2())
  if(parseInt(this.selectedRange.max)-parseInt(this.selectedRange.min)<= this.minGap){
    this.selectedRange.max=parseInt(this.selectedRange.min) + this.minGap;
  }
}
}
splitRange1() {
  const [start, end] = this.originalRange1.split('-').map(Number);
  this.subRanges = [];
  for (let i = start; i < end; i += 100) {
    const subrangeStart = i;
    const subrangeEnd = i + 100;
    const subrange = `${subrangeStart}-${subrangeEnd}`;
    this.subRanges.push(subrange);
    console.log("subRanges",JSON.stringify(this.subRanges))
  }
  this.callListingScreen()

}
scrollchange1(){
  this.slideOne1();
  this.slideTwo1();
  this.originalRange1 = this.selectedRange1.min + '-' + this.selectedRange1.max
  this.splitRange1();
}


slideOne1(){
  if(this.selectedRange1.min == 650){
  if(this.selectedRange1.max-parseInt(this.selectedRange1.min)<= this.minGap1){
    this.selectedRange1.min=parseInt(this.selectedRange1.max) - this.minGap1;
    
  }
}
}
slideTwo1(){
  if(this.selectedRange.min !== 650){
    // this.inputValue1.addEventListener("input",this.listener2())
  if(parseInt(this.selectedRange1.max)-parseInt(this.selectedRange1.min)<= this.minGap1){
    this.selectedRange1.max=parseInt(this.selectedRange1.min) + this.minGap1;
  }
}
}
listener1(){
if (this.selectedRange.min >= this.selectedRange.max)
      this.selectedRange.max = this.selectedRange.max+ this.minGap;
    }
    listener2(){
      if (this.selectedRange.min >= this.selectedRange.max)
      this.selectedRange.min = this.selectedRange.min - this.minGap;
          }
          // updateMinMaxValues() {
          //   const currentRange = parseInt(this.selectedRange.min.value, 10);
          //   const minRange = Math.min(currentRange, this.selectedRange.max);
          //   const maxRangeAfterMinCheck = Math.max(minRange, currentRange);
          //   this.minOutput.textContent = `Min Value: ${minRange}`;
          //   this.maxOutput.textContent = `Max Value: ${maxRangeAfterMinCheck}`;
          // }
          controlToSlider(fromSlider, toSlider) {
            
            fromSlider = this.inputValue1
            toSlider = this.inputValue2
            let [from, to] = this.getParsed(fromSlider, toSlider);
            // this.setToggleAccessible(this.inputValue1);
            if (from <= to) {
              this.inputValue1.value = this.selectedRange.max-this.minGap;
            } else {
              this.inputValue1.value = from+50;
            }
          }
          
             getParsed(currentFrom, currentTo) {
            let from = parseInt(currentFrom.value, 10);
            let to = parseInt(currentTo.value, 10);
            return [from, to];
          }
          setToggleAccessible(currentTarget) {
            if (Number(currentTarget.value) <= 0) {
              this.inputValue2.style.zIndex = 2;
            } else {
              this.inputValue2.style.zIndex = 0;
            }
          }
          controlFromSlider(fromSlider, toSlider) {
            fromSlider = this.inputValue1;
            toSlider = this.inputValue2;
            let [from, to] = this.getParsed(fromSlider, toSlider);
            // fillSlider(fromSlider, toSlider, '#C6C6C6', 'brown', toSlider);
            if (from >= to) {
              toSlider.value = this.selectedRange.min+50;
            }
          }
          getCurrentURL () {
            return window.location.href
          }
}
